import { message } from "antd";
import { runInAction } from "mobx";

export class HttpUtils {

    handleResponse(response: Response, successHandler?: ((data: any | undefined | null) => any | undefined | null),
        errorHandler?: ((error: string) => any) | undefined | null) {

        if (response.status === 401) {
            window.location.replace("/login");
        }

        if (response.ok) {
            if (successHandler !== null && successHandler !== undefined) {

                response.text().then(text => {

                    const data = text && JSON.parse(text);

                    runInAction(() => {
                        successHandler(data);
                    })
                }
                );
            }

            return;
        }


        if (!response.ok) {

            response.json().then(
                error => {

                    const errorMessage = (error && error.detail) || response.statusText;

                    if (errorHandler !== null && errorHandler !== undefined) {
                        runInAction(() => errorHandler(errorMessage))
                    } else {
                        message.error(`Ошибка при выполнении запроса: ${errorMessage}`);
                    }
                }
            ).catch((_) => message.error('Сервер не отвечает'));
        }
    }
}